<div class="item-panel">
	<div class="heading"><b>{{ asset.alt_asset_term || brand.assetSingular}}</b> - {{asset.asset_name}}<span *ngIf="asset.asset_serial_number"> ({{asset.asset_serial_number}})</span><span *ngIf="asset.fleet_id === 0"> - {{asset.organization_name}}</span></div>
	<div class="content dark">
		<div class="row border-between">
			<div class="col-sm-4">
				<div><b>{{asset.alt_asset_term || brand.assetSingular}} Type:</b> {{asset.asset_type_name}}</div>
				<div *ngIf="!asset.is_fixed && asset.flight_time !== null"><b>{{brand.flightTime}}:</b> {{asset.flight_time | runtime}}</div>
			</div>
			<div class="col-sm-4">
				<div *ngIf="asset.rulmin"><b>RUL:</b> {{asset.rulmin | number : "1.2-2"}} hours</div>
			</div>
			<div class="col-sm-4">
				<app-health-indicator [hi]="asset.totalhimax"></app-health-indicator>
			</div>
		</div>
	</div>
</div>